import { ResponsiveImage } from '@sleepstation/components'
import { CopyParagraph } from '@sleepstation/components-copy'
import { HLayout, VList } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN, LAYOUT_SPACING } from '@sleepstation/const'
import { color, marginTop, paddingLeft } from '@sleepstation/style-api-helpers'
import { renderList } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import styled, { ThemeProvider } from 'styled-components'
import infoCardThemeBlue from '../../../../../../themes/infoCardThemeBlue'
import thoughtBubbleSvg from '../../../../../../../content/images/illustrations/cards/thought-bubble.svg'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const IMAGE = {
  aspectRatio: `30 / 39`,
  altText: `Thought bubble`,
}

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VList).attrs({ spacing: LAYOUT_SPACING.MEDIUM_LARGE })`
  ${marginTop(1)}
`

const Belief = styled(CopyParagraph)`
  ${paddingLeft(0.25)}
  ${color(`highlight`)}
`

const Wrapper = styled(HLayout).attrs({
  align: LAYOUT_ALIGN.TOP,
})``

const ImageWrapper = styled.div`
  > * {
    width: 30px;
  }
`

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const List = ({ beliefs }) => (
  <Layout>
    {renderList(
      (belief) => (
        <ThemeProvider theme={infoCardThemeBlue}>
          <Wrapper>
            <ImageWrapper>
              <ResponsiveImage
                aspectRatio={IMAGE.aspectRatio}
                src={thoughtBubbleSvg}
                alt={IMAGE.altText}
              />
            </ImageWrapper>
            <Belief>{belief}</Belief>
          </Wrapper>
        </ThemeProvider>
      ),
      beliefs
    )}
  </Layout>
)

List.propTypes = {
  beliefs: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default List
